import { createSlice } from "@reduxjs/toolkit";

const getInitialBaseUrl = () => {
    if (typeof window !== "undefined" && window.location) {
        const hostname = window.location.hostname;
        if (hostname && hostname !== "localhost" && hostname !== "127.0.0.1") {
            return `${window.location.origin}/`;
        }
    }
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL.endsWith("/")
            ? process.env.REACT_APP_API_URL
            : `${process.env.REACT_APP_API_URL}/`;
    }
    return "http://localhost:8000/";
};

const initialState = {
    baseUrl: getInitialBaseUrl(),
};

const ApiBaseUrlSlice = createSlice({
    name: "ApiBaseUrl",
    initialState,
    reducers: {
        setApiBaseUrl: (state, action) => {
            state.baseUrl = action.payload;
        }
    }
});

export const { setApiBaseUrl } = ApiBaseUrlSlice.actions;
export default ApiBaseUrlSlice.reducer;
